import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FingoDivider } from '../../../components/dividers';
import { PaperHeader } from '../../../components/headers';
import CredentialsCard from '../../../components/profile/credentials/CredentialsCard';

const CredentialsView = ({
  useCompanyCredentials,
  showPaperHeader,
  title,
  description,
  secondaryDescription,
  stackSx,
  stackProps,
  gridRowSpacing,
  gridColumnSpacing,
  descriptionSx,
  secondaryDescriptionSx,
}) => {
  const companyCredentials = useCompanyCredentials().filter((cred) => cred.showInCredentials);

  return (
    <Stack sx={stackSx} {...stackProps}>
      {showPaperHeader ? (
        <>
          <PaperHeader viewTitle={title} />
          <FingoDivider />
          <Typography sx={descriptionSx}>
            {description}
          </Typography>
          <Typography sx={secondaryDescriptionSx}>
            {secondaryDescription}
          </Typography>
        </>
      ) : (
        <Stack direction="column">
          <Typography variant="large_3" color="text.primary" fontWeight={700}>
            {title}
          </Typography>
          <Typography variant="small_3" sx={descriptionSx}>
            {description}
          </Typography>
          <Typography variant="small_3" sx={secondaryDescriptionSx}>
            {secondaryDescription}
          </Typography>
        </Stack>
      )}
      <Grid container rowSpacing={gridRowSpacing} columnSpacing={gridColumnSpacing}>
        {companyCredentials.map((document) => (
          <Grid key={document.title} item xs={12} md={6}>
            <CredentialsCard {...document} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

CredentialsView.propTypes = {
  useCompanyCredentials: PropTypes.func.isRequired,
  showPaperHeader: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.node.isRequired,
  secondaryDescription: PropTypes.node.isRequired,
  stackSx: PropTypes.shape({}),
  stackProps: PropTypes.shape({}),
  gridRowSpacing: PropTypes.number,
  gridColumnSpacing: PropTypes.shape({}),
  descriptionSx: PropTypes.shape({}),
  secondaryDescriptionSx: PropTypes.shape({}),
};

CredentialsView.defaultProps = {
  showPaperHeader: false,
  title: 'Mis credenciales',
  stackSx: undefined,
  stackProps: {},
  gridRowSpacing: 3,
  gridColumnSpacing: { xs: 0, md: 3 },
  descriptionSx: undefined,
  secondaryDescriptionSx: undefined,
};

export default CredentialsView;
